import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../api';
import Layout from '../components/Layout';

export default function MemberProfileEdit() {
  const { id } = useParams();
  const [member, setMember] = useState(null);
  const [motorTypes, setMotorTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [uploadingPhoto, setUploadingPhoto] = useState(false);
  const [form, setForm] = useState({ name: '', bio: '', quote: '', photo_url: '', motor_type_id: '' });

  useEffect(() => {
    Promise.all([
      api.get(`/member-auth/admin/${id}/full`),
      api.get('/motor-types'),
    ]).then(([memberRes, typesRes]) => {
      const m = memberRes.data;
      setMember(m);
      setForm({
        name: m.name || '',
        bio: m.bio || '',
        quote: m.quote || '',
        photo_url: m.photo_url || '',
        motor_type_id: m.motor_type_id || '',
      });
      setMotorTypes(typesRes.data);
    }).catch((err) => {
      console.error(err);
      alert('Gagal ambil data member');
    }).finally(() => setLoading(false));
  }, [id]);

  const handlePhotoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploadingPhoto(true);
    try {
      const fd = new FormData();
      fd.append('photo', file);
      const res = await api.post('/upload/admin/photo', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setForm((f) => ({ ...f, photo_url: res.data.url }));
    } catch (err) {
      alert('Gagal upload foto');
    } finally {
      setUploadingPhoto(false);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (form.quote.length > 150) {
      alert('Quote maksimal 150 karakter');
      return;
    }
    setSaving(true);
    try {
      await api.put(`/member-auth/admin/${id}/full-edit`, {
        ...form,
        motor_type_id: form.motor_type_id === '' ? null : Number(form.motor_type_id),
      });
      alert('Profil member berhasil diupdate');
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal update profil');
    } finally {
      setSaving(false);
    }
  };

  const inputStyle = { background: '#12151A', border: '1px solid #262b33', borderRadius: 6, padding: '10px 12px', color: '#F0EDE4', fontSize: 14, width: '100%' };
  const labelStyle = { fontSize: 12, color: '#8B92A0', marginBottom: 4, display: 'block' };

  if (loading) return <Layout><p style={{ color: '#8B92A0' }}>Memuat...</p></Layout>;
  if (!member) return <Layout><p style={{ color: '#D02127' }}>Member tidak ditemukan.</p></Layout>;

  return (
    <Layout>
      <Link to="/members" style={{ color: '#2B6996', fontSize: 13, textDecoration: 'none' }}>← Kembali ke Kelola Member</Link>
      <h1 style={{ fontSize: 26, fontWeight: 900, fontStyle: 'italic', margin: '12px 0 24px' }}>
        Edit Profil — {member.name}
      </h1>
      <p style={{ color: '#8B92A0', fontSize: 12, marginBottom: 20, maxWidth: 500 }}>
        Halaman ini buat moderasi — koreksi nama/bio/quote/foto/tipe motor member kalau ada konten yang gak pantas atau butuh diperbaiki.
      </p>

      <form onSubmit={handleSave} style={{ maxWidth: 480, display: 'flex', flexDirection: 'column', gap: 14 }}>
        <div>
          <div style={{ width: 90, height: 90, borderRadius: '50%', background: '#1C2128', overflow: 'hidden', marginBottom: 10, border: '2px solid #262b33' }}>
            {form.photo_url && <img src={form.photo_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
          </div>
          <label style={{ display: 'inline-block', background: '#2B6996', color: '#fff', padding: '8px 16px', borderRadius: 6, fontSize: 12, cursor: 'pointer', fontWeight: 700 }}>
            {uploadingPhoto ? 'Mengupload...' : 'Ganti Foto'}
            <input type="file" accept="image/*" onChange={handlePhotoUpload} style={{ display: 'none' }} />
          </label>
        </div>

        <div>
          <label style={labelStyle}>Nama</label>
          <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} style={inputStyle} />
        </div>

        <div>
          <label style={labelStyle}>Quote / Motto (maks 150 karakter)</label>
          <input
            value={form.quote}
            onChange={(e) => setForm({ ...form, quote: e.target.value })}
            maxLength={150}
            style={inputStyle}
          />
          <p style={{ fontSize: 10, color: '#5a616e', marginTop: 4 }}>{form.quote.length}/150</p>
        </div>

        <div>
          <label style={labelStyle}>Bio</label>
          <textarea value={form.bio} onChange={(e) => setForm({ ...form, bio: e.target.value })} rows={3} style={inputStyle} />
        </div>

        <div>
          <label style={labelStyle}>Tipe Motor</label>
          <select
            value={form.motor_type_id}
            onChange={(e) => setForm({ ...form, motor_type_id: e.target.value })}
            style={inputStyle}
          >
            <option value="">Belum pilih tipe</option>
            {motorTypes.map((t) => (
              <option key={t.id} value={t.id}>{t.name}</option>
            ))}
          </select>
        </div>

        <button type="submit" disabled={saving} style={{ background: '#D02127', color: '#fff', border: 'none', padding: 12, borderRadius: 6, fontWeight: 700, cursor: 'pointer', marginTop: 8 }}>
          {saving ? 'Menyimpan...' : 'Simpan Perubahan'}
        </button>
      </form>
    </Layout>
  );
}
